import { Box, useTheme } from "@mui/material";
import React from 'react'
import { useSelector } from 'react-redux';

export default function Bid({ symbolId = 7, digits }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    const theme = useTheme();

    const getColor = () => {
        if (symbol?.askColor === 'up') return '#079a80';     // green
        if (symbol?.askColor === 'down') return '#da5244';   // red
        return theme.palette.text.secondary;                 // fallback
    };

    const convertAmount = () => {
        const bid = symbol?.bid?.toFixed(symbol?.digits).toString() || '0.00';
        const [intPart, decimals = ''] = bid.split('.');
        const textColor = getColor();

        if (decimals.length > 2) {
            const lastThree = decimals.slice(-3); // last 3 digits
            const rest = decimals.slice(0, -3);   // everything before the last 3
            const bigPart = lastThree.slice(0, 2);
            const superPart = lastThree.slice(2);
            return (
                // <Box sx={{ display: "flex", alignItems: 'end', minWidth: "60px", justifyContent: "end" }} className={`${symbol?.bidColor == 'up' ? 'green' : symbol?.bidColor == 'down' && 'red'}`}>
                <Box sx={{ display: "flex", alignItems: 'end', justifyContent: "end", minWidth: "60px", color: textColor }}>
                    <div style={{ fontSize: 15, fontWeight: 600 }}>{intPart}.{rest}</div>
                    <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.3 }}>{bigPart}</div>
                    <div style={{ fontSize: 15, fontWeight: 600, alignSelf: "start" }}>{superPart}</div>
                </Box>
            )
        } else {
            // If 2 or fewer decimal digits, show last 2 big
            const padded = decimals.padEnd(2, '0'); // 2 digits
            const bigPart = padded.slice(-2);
            const rest = padded.length > 2 ? padded.slice(0, -2) : '';
            return (
                <Box sx={{ display: "flex", alignItems: 'end', justifyContent: "end", minWidth: "60px", color: textColor }}>
                    {/* <Box sx={{ display: "flex", alignItems: 'end', minWidth: "60px", justifyContent: "end" }} className={`${symbol?.bidColor == 'up' ? 'green' : symbol?.bidColor == 'down' && 'red'}`}> */}
                    <div style={{ fontSize: 15, fontWeight: 600 }}>{intPart}.{rest}</div>
                    <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.3 }}>{bigPart}</div>
                </Box>
            )
        }
    }

    return (
        convertAmount()
    );
}
